// SavedQueryManager.jsx
import React, { useState } from "react";
import axios from "axios";
import endpoints from "../config";
import { toast } from "react-toastify";
import ConfirmModal from "./ConfirmModal";
// import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; 

const SavedQueryManager = ({ savedQueries, onSave, onLoad, onDelete, fetchQueries }) => { 
  const [showModal, setShowModal] = useState(false);
  const [toDeleteId, setToDeleteId] = useState(null);

  const {authToken} = useAuth() 
 
 

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`${endpoints.queries.advanceDeleteSavedQuery}${toDeleteId}`, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      toast.success("Query deleted");
      setShowModal(false);
      setToDeleteId(null);
      fetchQueries();
    } catch {
      toast.error("Failed to delete query");
    }
  };

  const handleCancelDelete = () => {
    setShowModal(false);
    setToDeleteId(null);
  };

  return (
    <div>
      
      
      {savedQueries.length > 0 && (
  <>
    <h5 className="bg-secondary text-white px-2 py-2 mt-2 border rounded" style={{ position: "sticky", top: 0, zIndex: 1 }}>
      Segmentations
    </h5>

    <ul className="list-group" style={{ maxHeight: "200px", overflowY: "auto" }}>
      {savedQueries.map(q => (
        <li
          className="list-group-item d-flex justify-content-between align-items-center"
          key={q.id}
        >
          <span className="text-truncate" title={q.name}>{q.name}</span>

          <div className="d-flex gap-1">
            {/* Load Button */}
            <button
              className="btn btn-sm btn-primary d-flex align-items-center"
              onClick={() => onLoad(q.id)}
              title="Load"
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
            </button>

            {/* Delete Button */}
            <button
              className="btn btn-sm btn-danger d-flex align-items-center"
              onClick={() => {
                setToDeleteId(q.id);
                setShowModal(true);
              }}
              title="Delete"
            >
              <i className="fa-solid fa-trash col text-white "></i>
            </button>
          </div>
        </li>
      ))}
    </ul>
  </>
)}


      

      {showModal && (
        <ConfirmModal
          show={showModal}
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
          title="Delete Query"
          message="Are you sure you want to delete this saved query?"
        />
      )}
    </div>
  );
};

export default SavedQueryManager;
